import { forwardRef, useState } from "react";
import { getSrcSet, getSizes, buildCmsUrl } from "../../utils/imageHelper";



/*eslint-disable */

declare const window: any;

interface ModelosVehiculosComponentProps {
  modelos: any;
  reserva: any;
}

const ModelosVehiculosComponent = forwardRef<
  HTMLDivElement,
  ModelosVehiculosComponentProps
>(({ modelos, reserva }, ref) => {
  
  const [selectedVersion, setSelectedVersion] = useState(0);
  const [selectedVersionColor, setSelectedVersioncolor] = useState(0);

  const formatCurrency = (value: number) => {
    return new Intl.NumberFormat("es-CO", {
      style: "currency",
      currency: "COP",
      minimumFractionDigits: 0,
    }).format(value);
  };

  return (
    <div className="modelos-vehiculos-detail-component" ref={ref}>
      {/* H2 - Título principal de la sección "Más de una posibilidad en tu Hyundai..." */}
      <h2 className="title-modelos-vehiculos-detail-component">
        {modelos?.title_versions}
      </h2>
      
      {/* H3 - Contenedor de versiones (cada versión es un H3) */}
      <div className="version-modelos-vehiculos-detail-component">
        {modelos?.modelos?.map((model: any, index: number) => (
          <h3
            key={index}
            className={`item-version-modelos-vehiculos-detail-component ${
              model.title === modelos?.modelos[selectedVersion]?.title
                ? "active"
                : ""
            }`}
            onClick={() => setSelectedVersion(index)}
          >
            {model.title}
          </h3>
        ))}
      </div>
      
      {/* H4 - Nombre de la versión seleccionada */}
      <h4 className="name-version-modelos-vehiculos-detail-component">
        Versión {modelos?.modelos[selectedVersion]?.title}
      </h4>
      
      {/* H5 - Precio de la versión */}
      <h5 className="precio-version-modelos-vehiculos-detail-component">
        Disponible desde {formatCurrency(modelos?.modelos[selectedVersion]?.price)} *
      </h5>
      
      <div className="asset-color-version-modelos-vehiculos-detail-component">
        <div className="asset-version-modelos-vehiculos-detail-component">
          {modelos?.modelos[selectedVersion]?.colors[selectedVersionColor].image !== null ? (
            <img
              src={buildCmsUrl(modelos?.modelos[selectedVersion]?.colors[selectedVersionColor].image?.url)}

              srcSet={getSrcSet(modelos?.modelos[selectedVersion]?.colors[selectedVersionColor].image?.url || '')}
              sizes={getSizes('800px')}
              alt={`Imagen del modelo ${modelos?.modelos[selectedVersion]?.title} en color ${modelos?.modelos[selectedVersion]?.colors[selectedVersionColor].name}`}
            />

          ) : null}
        </div>
        
        <div className="control-color-version-modelos-vehiculos-detail-component">
          <div
            className="colores-control-color-version-modelos-vehiculos-detail-component"
            style={
              modelos?.modelos[selectedVersion]?.colors?.length === 1
                ? { justifyContent: "center" }
                : {}
            }
          >
            {modelos?.modelos[selectedVersion]?.colors.map(
              (color: any, e: number) => (
                <div
                  key={e}
                  className={
                    modelos?.modelos[selectedVersion]?.colors[selectedVersionColor].name === color.name
                      ? "active"
                      : ""
                  }
                  style={{
                    backgroundColor: color.color,
                    border: `2px solid ${color.color}`,
                  }}
                  onClick={() => setSelectedVersioncolor(e)}
                ></div>
              )
            )}
          </div>
          
          {/* H4 - Nombre del color (mismo nivel que el nombre de la versión) */}
          <h4 className="title-control-color-version-modelos-vehiculos-detail-component">
            {modelos?.modelos[selectedVersion]?.colors[selectedVersionColor].name}
          </h4>
          
          <div className="politica-control-color-version-modelos-vehiculos-detail-component">
            *Los valores y precios publicados son de referencia y pueden variar sin previo aviso. Las imágenes son ilustrativas, algunas características de los vehículos de las imágenes pueden variar.
          </div>
        </div>
      </div>
      
      {/* H3 - Título de la sección de características (implícito en el contenedor) */}
      <div className="caracteristica-version-modelos-vehiculos-detail-component">
        {modelos?.modelos[selectedVersion]?.features.map(
          (item: any, index: number) => (
            <div key={index} className="item-caracteristica-version-modelos-vehiculos-detail-component">
              {/* H4 - Título de cada característica (ej: "Rines en aluminio bitono") */}
              <h4 className="title-item-caracteristica-version-modelos-vehiculos-detail-component">
                {item?.title}
              </h4>
              
              {/* H5 - Descripción de la característica (ej: "Diámetro de 18 pulgadas.") */}
              <h5 className="description-item-caracteristica-version-modelos-vehiculos-detail-component">
                {item?.description}
              </h5>
            </div>
          )
        )}
      </div>
      
      {reserva && reserva.length > 0 ? (
        <a
          href={reserva}
          target="_blank"
          className="compara-version-modelos-vehiculos-detail-component"
        >
          Compara las versiones
        </a>
      ) : null}
    </div>
  );
});

export default ModelosVehiculosComponent;